module.exports = __webpack_public_path__ + "static/media/1-5.90f2853f.mp3";